import { MasterOrderBy } from '@/common/api/modules/master'
import { ListFollowTableHeaderProps, makeRectPropsForTableHeadItem } from '@/common/app/list'

import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import ListHeaderSortButton from '@/components/view/atoms/icon/ListHeaderSortButton'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface TheadProps extends ListFollowTableHeaderProps {
  selected: boolean
  allSelected: boolean
  onCheck(checked: boolean): void
  orderBy: MasterOrderBy | null
  onChangeOrderBy(orderBy: MasterOrderBy | null): void
  float?: boolean
}

export const W2_PRODUCT_TABLE_COLUMN_LENGTH = 11

const W2ProductListThead = ({
  selected,
  allSelected,
  onCheck,
  orderBy,
  onChangeOrderBy,
  float = false,
  isScrolled,
  rowRefs,
  rowRects
}: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem checkbox sticky={0} float={float} {...rectProps(0)}>
        <CheckBox name={'all'} checked={selected} onChange={onCheck} incomplete={!allSelected} />
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(1)}>
        <Text color={TextColor.SECONDARY} size={12}>
          店舗ID
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(2)}>
        <Text color={TextColor.SECONDARY} size={12}>
          商品ID
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(3)}>
        <Text color={TextColor.SECONDARY} size={12}>
          商品名
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(4)}>
        <Text color={TextColor.SECONDARY} size={12}>
          表示価格
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(5)}>
        <Text color={TextColor.SECONDARY} size={12}>
          カテゴリID1
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(6)}>
        <Text color={TextColor.SECONDARY} size={12}>
          ブランドID1
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(7)}>
        <Text color={TextColor.SECONDARY} size={12}>
          定期購入
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(8)}>
        <Text color={TextColor.SECONDARY} size={12}>
          有効フラグ
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(9)}>
        <Text color={TextColor.SECONDARY} size={12}>
          削除フラグ
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(10)}>
        <ListHeaderSortButton
          order={
            orderBy == MasterOrderBy.CREATED_AT_ASC
              ? 'asc'
              : orderBy == MasterOrderBy.CREATED_AT_DESC
                ? 'desc'
                : undefined
          }
          onChange={(order) =>
            onChangeOrderBy(
              order == 'desc' ? MasterOrderBy.CREATED_AT_DESC : MasterOrderBy.CREATED_AT_ASC
            )
          }
          text='作成日時'
        />
      </TableHeadItem>
    </>
  )
}

export default W2ProductListThead
